import React from "react";
import {
    AutocompleteInput,
    BooleanInput,
    Edit,
    EditProps,
    required,
    SimpleForm,
    TextInput,
    TitleProps, usePermissions,
} from "react-admin";
import { useCountries } from "api/enums";
import { useTranslation } from "react-i18next";
import { EditToolbar } from "components/editToolbar";
import { Capability } from "reactAdmin/capabilities";

const OrganizationTitle = (props: TitleProps) => {
    const { t } = useTranslation();
    return <span>{t('resource.organization')} {props.record ? `"${props.record.name}"` : ''}</span>;
};

export const OrganizationEdit = (props: EditProps) => {
    const { t } = useTranslation();
    const countryResult = useCountries();
    const { loading, permissions: isAuthorized } = usePermissions();

    if (loading) {
        return null
    }

    return (
        <Edit
            title={<OrganizationTitle />}
            {...props}
        >
            <SimpleForm
                toolbar={<EditToolbar showDelete={isAuthorized && isAuthorized(Capability.DELETE_ORGANIZATION)} />}
                redirect={isAuthorized && isAuthorized(Capability.MANAGE_ORGANIZATION) ? false : 'list'}
            >
                <TextInput source="name" validate={[required()]} />
                <BooleanInput source="isActive" />
                <TextInput label={t("address.street")}source="address.street" />
                <TextInput label={t("address.addressLine2")}source="address.addressLine2" />
                <TextInput label={t("address.city")}source="address.city" />
                <TextInput label={t("address.state")}source="address.state" />
                <TextInput label={t("address.zipCode")}source="address.zipCode" />
                <AutocompleteInput
                    label={t("address.country")}
                    source="address.countryId"
                    choices={(countryResult.data || []).map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))}
                    validate={[required()]}
                />
            </SimpleForm>
        </Edit>
    );
}